// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"f6a6308d","36":"fcfa56e7","130":"f6a6308d","717":"f55ae2c2","805":"68187181","920":"61f76d9a","940":"6f1031d6"}[chunkId] + ".css";
};